import { Box, Typography } from '@mui/material';
import React from 'react';
import { gradients } from '../../utils/theme';

const pageTitleSx = {
    pageTitleSection: {
        width: '100%',
        paddingTop: { xs: '1rem', sm: '3rem' },
        paddingBottom: { xs: '1rem', sm: '2rem' },
        backgroundColor: 'white',
        textAlign: { xs: 'center', sm: 'unset' },
    },
    pageTitleContainer: {
        width: '100%',
    },
    title: {
        backgroundImage: gradients.main,
        WebkitBackgroundClip: 'text',
        backgroundClip: 'text',
        color: 'transparent',
        fontSize: { xs: 36, sm: 48, md: 55 },
        fontWeight: 500,
        paddingBottom: '5px',
    },
    titleCompact: {
        fontSize: { xs: 24, sm: 30, md: 34 },
    },
    tagline: {
        color: 'primary.dark',
        fontSize: { xs: 18, sm: 20, md: 24 },
        opacity: 0.8,
        fontWeight: 400,
    },
    taglineCompact: {
        fontSize: { xs: 15, sm: 16, md: 18 },
    },
} as const;

interface TitleProps {
    title: string;
    tagline: string;
    compact?: boolean;
}

export default function PageTitle({ title, tagline, compact }: TitleProps) {
    return (
        <Box sx={pageTitleSx.pageTitleSection}>
            <Box sx={pageTitleSx.pageTitleContainer}>
                <Typography variant="h1" sx={[pageTitleSx.title, compact && pageTitleSx.titleCompact]}>
                    {title || ''}
                </Typography>
                <Typography variant="h6" sx={[pageTitleSx.tagline, compact && pageTitleSx.taglineCompact]}>
                    {tagline || ''}
                </Typography>
            </Box>
        </Box>
    );
}
